import { render, staticRenderFns } from "./CalendarFooter.vue?vue&type=template&id=ea6d9c04"
import script from "./CalendarFooter.vue?vue&type=script&lang=ts"
export * from "./CalendarFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports